import merge from 'helpful-merge';

const resolveConfigActions = value => ({
    configure(nextOptions) {
        merge(value, nextOptions, {
            deep: true,
        });
    },
});

export default resolveConfigActions;
